// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3wqUS","icon":"SortAdornment_icon__2C3e3","up":"SortAdornment_up__2TfMt","down":"SortAdornment_down__3v0Sm","active":"SortAdornment_active__djR-x"};